module.exports = __webpack_public_path__ + "static/img/cDR10.2d8688fb.png";